import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

import { usePublications, usePublicationHistoryFilters } from "hooks/tivoApps";
import { usePlatforms } from "hooks/tivoDevices";

import { parseLocationToQueryParams } from "../../utils";

export function usePublicationsData() {
  const location = useLocation();
  const { tabId = "" } = useParams();
  const {
    data: historyFilters,
    isLoading: historyFiltersLoading,
    error: historyFiltersError,
  } = usePublicationHistoryFilters();
  const {
    data: platforms,
    isLoading: platformsLoading,
    error: platformsError,
  } = usePlatforms({ include: ["oems", "oems.clientTypes"] });

  const queryParams = useMemo(() => {
    const qp = parseLocationToQueryParams(location);
    const keysToDelete =
      historyFilters?.results.map((filter) => filter.id) ?? [];
    for (const key of Object.keys(qp)) {
      if (keysToDelete.includes(key)) {
        delete qp[key];
      }
    }
    return qp;
  }, [historyFilters, location]);

  const {
    data: publications,
    isLoading: publicationsLoading,
    error: publicationsError,
  } = usePublications(tabId, {
    ...queryParams,
    include: [
      "oems",
      "oems.clientTypes",
      "variant",
      "variant.versions",
      "variant.provider",
    ],
  });

  return {
    platforms: platforms?.results || [],
    status: {
      count: publications?.meta?.total || 0,
      error: historyFiltersError || platformsError || publicationsError,
      loading: historyFiltersLoading || platformsLoading || publicationsLoading,
    },
    publications: publications?.results || [],
  };
}
